<div class="main-footer">
  @if (translate.currentLang() == 'en') {
  <a class="coupon-button inverse" target="_blank" href="https://www.elite-it.com/en/pages/garanzia-legale-garanzia-commerciale">
    Terms and conditions
  </a>
  }
  @else {
  <a class="coupon-button inverse" target="_blank" href="https://www.elite-it.com/it/pagine/garanzia-legale-garanzia-commerciale">
    Termini e condizioni
  </a>
  }

  <div class="spacer"></div>

  @if (translate.currentLang() == 'en') {
  <a class="coupon-button inverse" target="_blank" href="https://elitesrl.zendesk.com/hc/en-us/articles/29367129190044-How-to-Register-an-ELITE-Product-Redeem-Coupons-and-Extend-Your-Warranty">
    Help
  </a>
  }
  @else {
  <a class="coupon-button inverse" target="_blank" href="https://elitesrl.zendesk.com/hc/it/articles/29367129190044-Come-registrare-un-prodotto-Elite-riscattare-i-coupon-ed-estendere-la-garanzia">
    Aiuto
  </a>
  }
</div>
